module.exports = new __parcel__URL__("play-button-pages.233781be.svg").toString();